import React from 'react';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-laptop-code',
      title: 'IT and Tech Services',
      description: 'We design and deliver modern digital solutions, including:',
      features: [
        'Web platforms',
        'Mobile applications',
        'SaaS tools',
        'Infrastructure-as-code (IaC)',
        'Microservices & containerized applications',
        'API-first design'
      ]
    }
  ];

  const whyChooseUs = [
    'Secure, scalable software with built-in automation',
    'Product-focused, not service/consulting-driven',
    'Trusted network of independent global partners'
  ];

  return (
    <section id="services" className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">Our Services</h2>
            <p className="lead text-muted">Professional delivery of modern digital solutions tailored to your business needs.</p>
          </div>
        </div>
        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-lg-8 mx-auto">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center p-5">
                  <div className="service-icon mb-4">
                    <i className={`${service.icon} fa-4x text-primary`}></i>
                  </div>
                  <h4 className="card-title fw-bold">{service.title}</h4>
                  <p className="card-text text-muted mb-4">
                    {service.description}
                  </p>
                  <ul className="list-unstyled text-start">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="mb-2">
                        <i className="fas fa-check text-success me-2"></i>{feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <div className="bg-light p-4 rounded">
              <h4 className="fw-bold text-primary mb-3 text-center">Why Choose Us?</h4>
              <ul className="list-unstyled">
                {whyChooseUs.map((item, index) => (
                  <li key={index} className="mb-2">
                    <i className="fas fa-check text-success me-2"></i>{item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;

